import { createAction } from 'redux-actions';
import { API_TENANT_NEW_TERM_SCHOOL_CLASS_SETTING } from 'constants/endpoints';
import { StatusEnum } from 'flex/actions/http/StatusEnum';

/**
 * Prefix 付きの ActionType を作成する
 */
const createActionType = <ActionType extends string>(actionType: ActionType) => {
    const prefix = 'CONNECTION/TENANT_NEW_TERM_SCHOOL_CLASS_SETTING';
    return `${prefix}/${actionType}` as `${typeof prefix}/${ActionType}`;
};

export const view = createAction(
    createActionType('VIEW' as const),
    () => {
        return {
            method: 'get',
            api: `${API_TENANT_NEW_TERM_SCHOOL_CLASS_SETTING}/view`,
        };
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);

// 全体管理者
export const controlSave = createAction(
    createActionType('CONTROL_SAVE' as const),
    (data) => {
        return {
            method: 'post',
            data,
            api: `${API_TENANT_NEW_TERM_SCHOOL_CLASS_SETTING}/save`,
        };
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);

export const controlView = createAction(
    createActionType('CONTROL_VIEW' as const),
    () => {
        return {
            method: 'get',
            api: `${API_TENANT_NEW_TERM_SCHOOL_CLASS_SETTING}/view`,
        };
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);
